import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import KeyprIcon from '@keypr/icon-font';

import { workOrders as statusOptions } from '../../config/service-options';
import formUtils from '../../utils/forms';
import Select from '../../components/Select';
import Checkbox from '../../components/Checkbox';
import GenericFormItem from '../../components/GenericFormItem';
import AutocompleteLocations from '../../components/AutocompleteLocations';
import { localize } from '../../i18n';

const defaultState = {
  form: {
    type: null,
    locations: [],
    priority: 0,
    body: {},
  },
  no_due_date: false,
  formSubmittable: false,
  departmentFilter: 'all',
};

class WorkorderFormCard extends Component {
  constructor(props) {
    super(props);
    this.didProcessRequest = false;
    this.state = Object.assign({}, defaultState, this.props.workorderForm);
  }

  componentWillMount() {
    if (this.props.edit) {
      const noDueDate = (this.props.workorderForm.form.due_date === null && !this.state.no_due_date);
      this.setState(Object.assign({}, this.state, {
        no_due_date: noDueDate,
        originalStatus: this.state.form.status,
      }));
    }
  }

  componentWillReceiveProps(nextProps) {
    const newForm = Object.assign({}, this.state.form);
    // if (nextProps.addedComments.length > 0) {
    //   newForm.comments = nextProps.addedComments;
    // }
    if (nextProps.selectedLocations.length > 0) {
      newForm.locations = nextProps.selectedLocations;
    }
    this.setState(Object.assign({}, this.state, {
      form: newForm,
    }), () => {
      this.checkFormSubmittable();
    });
  }

  handleValueChange(name, val) {
    let value = val;
    const newFormValues = Object.assign({}, this.state.form);

    if (name === 'priority') {
      value = parseInt(val, 10);
    }
    if (name === 'status') {
      if (
        ['new', 'acknowledged'].indexOf(newFormValues.status) === -1
        && ['new', 'acknowledged'].indexOf(value) !== -1
        && newFormValues.assigned !== null
      ) {
        newFormValues.assigned = null;
      }
    }
    if (name === 'assigned') {
      const assignee = _.find(this.props.staffList, { id: value });
      if (assignee) {
        value = {
          id: assignee.id,
          full_name: `${assignee.first_name} ${assignee.last_name}`,
        };
        if (newFormValues.status === 'new' || newFormValues.status === 'acknowledged') {
          newFormValues.status = 'assigned';
        }
      } else if (value === null && newFormValues.status === 'assigned') {
        newFormValues.status = this.props.workorderForm.form.status;
      }
    }
    newFormValues[name] = value;
    this.setState(Object.assign({}, this.state, {
      form: newFormValues,
    }), () => {
      this.checkFormSubmittable();
    });
  }

  handleValueBodyChange(name, val) {
    const form = Object.assign({}, this.state.form);
    form.body[name] = val;
    this.setState(Object.assign({}, this.state, {
      form,
    }), () => {
      this.checkFormSubmittable();
    });
  }

  handleFilterDepartment(departmentFilter) {
    this.setState({
      departmentFilter,
    });
  }

  handleSubmitTouchTap() {
    if (this.state.formSubmittable === true) {
      this.props.onSubmit(this.state.form);
    }
  }

  toggleSection(section) {
    this.props.toggleSection(section, Object.assign({}, this.state));
  }

  updateCheck() {
    this.setState((oldState) => {
      const newFormValues = Object.assign({}, this.state.form);
      newFormValues.due_date = oldState.no_due_date ? this.state.form.due_date : null;
      return {
        form: newFormValues,
        no_due_date: !oldState.no_due_date,
      };
    });
  }

  checkFormSubmittable() {
    let formSubmittable = false;
    if (
      this.state.form.type !== null
      && this.state.form.priority !== ''
    ) {
      formSubmittable = true;
    }

    const typeWorkOrderConfig = _.find(this.props.workorderConfigs, { work_order_name: this.state.form.type });
    if (formSubmittable === true && typeWorkOrderConfig) {
      if (_.has(typeWorkOrderConfig, 'required_fields')) {
        typeWorkOrderConfig.required_fields.forEach((req) => {
          if (!this.state.form[req]) {
            formSubmittable = false;
          }
        });
      }
      if (formSubmittable === true && _.has(typeWorkOrderConfig, 'form')) {
        typeWorkOrderConfig.form.forEach((formConfig) => {
          if (formConfig.required === true && !this.state.form.body[formConfig.name]) {
            formSubmittable = false;
          }
        });
      }
    }

    this.setState({
      formSubmittable,
    });
  }

  render() {
    const {
      form: {
        type,
      },
      formSubmittable,
      departmentFilter,
    } = this.state;
    const {
      edit,
      workorderNumber,
      locationsLoaded,
      channels,
      locations,
      workorderConfigs,
      onCancel,
      selectedAffiliateInfo,
      selectedLocations,
      // addedComments,
      staffList,
      validStatusTransitions,
    } = this.props;

    const submitButtonDisabled = formSubmittable === false;
    let typeForm = null;

    let channelOptions = [{ value: '', label: (<span className="uk-text-italic">{this.props.t('Loading...')}</span>), labelString: this.props.t('Loading...') }];
    let channelOptionsDisabled = true;
    if (channels.length > 0) {
      channelOptions = _.map(channels, item => ({
        value: item.name,
        label: item.label,
      }));
      channelOptions.unshift({ value: 'all', label: this.props.t('All') });
      channelOptionsDisabled = false;
    }

    let workOrderTypeOptions = [{ value: '', label: (<span className="uk-text-italic">{this.props.t('Loading...')}</span>), labelString: this.props.t('Loading...') }];
    let workOrderTypeOptionsDisabled = true;
    if (workorderConfigs.length > 0) {
      let filteredWorkorderConfigs = workorderConfigs;
      if (departmentFilter && departmentFilter !== 'all') {
        filteredWorkorderConfigs = _.filter(workorderConfigs, config => config.channel === departmentFilter);
      }
      workOrderTypeOptions = _.map(filteredWorkorderConfigs, item => ({
        value: item.work_order_name,
        label: item.work_order_label,
      }));
      if (workOrderTypeOptions.length > 0) {
        workOrderTypeOptions.unshift({ value: '', label: this.props.t('Select...') });
        workOrderTypeOptionsDisabled = false;
      } else {
        workOrderTypeOptions.unshift({ value: '', label: this.props.t('No types...') });
      }
    }

    let typeWorkOrderConfig = null;
    let validStatusTransitionsOptions = [{ value: '', label: (<span className="uk-text-italic">{this.props.t('Loading...')}</span>), labelString: this.props.t('Loading...') }];
    let assigneesOptions = [{ value: '', label: (<span className="uk-text-italic">{this.props.t('Loading...')}</span>), labelString: this.props.t('Loading...') }];
    if (type !== null) {
      typeForm = [];
      // Add Summary field
      typeForm.push(formUtils.createItem('textfield', {
        name: 'summary',
        label: this.props.t('Summary'),
        val: this.state.form.summary || null,
        edit: true,
        onChange: (name, val) => this.handleValueChange(name, val),
      }));
      // Add Description field
      typeForm.push(formUtils.createItem('textfield', {
        name: 'description',
        label: this.props.t('Description'),
        val: this.state.form.description || null,
        edit: true,
        onChange: (name, val) => this.handleValueChange(name, val),
      }));

      if (workorderConfigs.length > 0) {
        // Add Form config fields
        typeWorkOrderConfig = _.find(workorderConfigs, { work_order_name: type });
        const body = {};
        typeWorkOrderConfig.form.forEach((item) => {
          body[item.name] = this.state.form.body[item.name] || null;
        });
        const options = {
          body,
          type,
          configs: workorderConfigs,
          title: 'work_order_name',
        };
        const props = {
          edit: true,
          onChange: (name, val) => this.handleValueBodyChange(name, val),
        };
        const typeBodyForm = formUtils.getFormItems(options, props);

        // Add form configured items
        typeForm = typeForm.concat(typeBodyForm);

        // Add Due date field
        if (!this.state.no_due_date) {
          /**
           * @param {{due_date_interval:string}} Due Time Interval
           */
          typeForm.push(formUtils.createItem('datetime', {
            name: 'due_date',
            label: this.props.t('Due'),
            val: this.state.form.due_date || null,
            timezone: selectedAffiliateInfo.attributes.timezone || null,
            edit: true,
            setDefault: true,
            roundTo: Math.floor(typeWorkOrderConfig.due_date_interval / 60),
            nearest: 'minutes',
            allowPastDates: false,
            onSave: (name, val) => this.handleValueChange(name, val),
          }));
        }
        typeForm.push((
          <div key="no-due-date" className="uk-grid">
            <div className="uk-width-medium-2-5 uk-width-small-1-3 uk-width-mobile-1-3 form-heading" />
            <div className="uk-width-medium-3-5 uk-width-small-2-3 uk-width-mobile-2-3 form-value dont-break-out">
              <Checkbox
                label={this.props.t('Due Date TBD')}
                checked={this.state.no_due_date}
                onChange={() => this.updateCheck()}
              />
            </div>
          </div>
        ));
      } else {
        typeForm.push((
          <div key="loading-configs" className="uk-grid">
            <div className="uk-width-small-1-1 uk-text-center">
              <div className="uk-text-italic">{this.props.t('Loading configs...')}</div>
            </div>
          </div>
        ));
      }

      if (edit === true) {
        // set the valid status transitions
        validStatusTransitionsOptions = _.filter(statusOptions, status => (validStatusTransitions.indexOf(status.value) !== -1));

        const originalStatusOption = _.find(statusOptions, { value: this.state.originalStatus });

        // Add original status option to transitions options array to be able select it before submitting for case
        // when it is absent in validStatusTransitionsOptions array
        if (!_.find(validStatusTransitionsOptions, originalStatusOption)) {
          validStatusTransitionsOptions.unshift(originalStatusOption);
        }

        // set the assignees options
        assigneesOptions = _.map(staffList, staff => ({
          value: staff.id,
          label: `${staff.first_name} ${staff.last_name}`,
        }));
        if (this.state.form.assigned && !_.find(assigneesOptions, { value: this.state.form.assigned.id })) {
          assigneesOptions.unshift({
            value: this.state.form.assigned.id,
            label: this.state.form.assigned.full_name,
          });
        }
        assigneesOptions.unshift({
          value: '',
          label: this.props.t('None'),
        });
      }
    }

    let formConfigItems = this.props.t('Loading...');
    if (edit === false) {
      formConfigItems = (
        <Select
          name="type"
          value={this.state.form.type}
          options={workOrderTypeOptions}
          onChange={value => this.handleValueChange('type', value)}
          clearable={false}
          disabled={workOrderTypeOptionsDisabled}
          openAfterFocus
        />
      );
    } else if (edit === true && typeWorkOrderConfig !== null) {
      formConfigItems = (
        <div>
          <span className="menu_icon"><KeyprIcon icon={typeWorkOrderConfig.icon} className="service-icon" /></span>
          {typeWorkOrderConfig.work_order_label}
        </div>
      );
    }

    const editWorkOrderHeadingText = workorderNumber ? this.props.t('Edit Work Order: #{workorderNumber}', { workorderNumber }) : '...';

    return (
      <div className="md-card">
        <div className="md-card-toolbar">
          <h3 className="md-card-toolbar-heading-text">
            {(edit === false) ? this.props.t('Create Work Order') : editWorkOrderHeadingText}
          </h3>
        </div>
        <div className="md-card-content md-card-mobile-height-viewport form-detail">
          <GenericFormItem label={this.props.t('Location')}>
            <AutocompleteLocations
              locations={locations}
              locationsLoaded={locationsLoaded}
              selectedLocations={selectedLocations}
              edit
              onChange={(changedLocations) => {
                this.handleValueChange('locations', changedLocations);
              }}
            />
          </GenericFormItem>
          <GenericFormItem label={this.props.t('Priority')}>
            <Select
              name="priority"
              value={this.state.form.priority}
              options={[
                { value: 0, label: this.props.t('Normal') },
                { value: 1, label: this.props.t('High') },
                { value: 2, label: this.props.t('Immediate') },
              ]}
              onChange={value => this.handleValueChange('priority', value)}
              clearable={false}
              openAfterFocus
            />
          </GenericFormItem>
          {(edit === false) ? (
            <GenericFormItem label={this.props.t('Department')}>
              <Select
                name="departmentFilter"
                value={this.state.departmentFilter}
                options={channelOptions}
                onChange={value => this.handleFilterDepartment(value)}
                clearable={false}
                disabled={channelOptionsDisabled}
                openAfterFocus
              />
            </GenericFormItem>
          ) : null}
          <GenericFormItem label={this.props.t('Type')}>
            {formConfigItems}
          </GenericFormItem>
          {typeForm}
          {(edit === true) ? [
            <GenericFormItem key="status" label={this.props.t('Status')}>
              <Select
                name="form-field-name"
                value={this.state.form.status}
                options={validStatusTransitionsOptions.map(o => (
                  {
                    ...o,
                    label: this.props.t(o.label),
                  }
                ))}
                onChange={value => this.handleValueChange('status', value)}
                clearable={false}
                openAfterFocus
              />
            </GenericFormItem>,
            <GenericFormItem key="assigned" label={this.props.t('Assigned To')}>
              <Select
                name="form-field-name"
                value={(this.state.form.assigned) ? this.state.form.assigned.id : null}
                options={assigneesOptions}
                onChange={value => this.handleValueChange('assigned', value)}
                clearable={false}
                openAfterFocus
              />
            </GenericFormItem>,
          ] : null}
        </div>
        <div className="md-card-footer uk-text-right">
          <button type="button" className="md-btn" onClick={evt => onCancel(evt)}>{this.props.t('Cancel')}</button>
          <button
            type="submit"
            className={`md-btn md-btn-wave-light waves-effect waves-button waves-light ${(submitButtonDisabled === true) ? 'disabled' : 'md-btn-primary'}`}
            disabled={submitButtonDisabled}
            onClick={() => this.handleSubmitTouchTap()}
          >
            {this.props.t('Submit')}
          </button>
        </div>
      </div>
    );
  }
}

WorkorderFormCard.propTypes = {
  edit: PropTypes.bool,
  workorderNumber: PropTypes.number,
  workorderForm: PropTypes.shape({
    form: PropTypes.shape({
      type: PropTypes.string,
      due_date: PropTypes.string,
      locations: PropTypes.arrayOf(PropTypes.object),
      priority: PropTypes.number,
      body: PropTypes.objectOf(PropTypes.any),
      status: PropTypes.string,
      assigned: PropTypes.shape({
        id: PropTypes.string,
        full_name: PropTypes.string,
      }),
    }),
    formSubmittable: PropTypes.bool,
    departmentFilter: PropTypes.string,
  }),
  locationsLoaded: PropTypes.bool,
  locations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    location_type: PropTypes.string,
    location_name: PropTypes.string,
    location_sort: PropTypes.number,
  })),
  // eslint-disable-next-line
  actionType: PropTypes.string,
  channels: PropTypes.arrayOf(PropTypes.object),
  staffList: PropTypes.arrayOf(PropTypes.object),
  workorderConfigs: PropTypes.arrayOf(PropTypes.object),
  selectedAffiliateInfo: PropTypes.shape({
    attributes: PropTypes.objectOf(PropTypes.any),
    id: PropTypes.string,
    type: PropTypes.string,
  }),
  validStatusTransitions: PropTypes.arrayOf(PropTypes.string),
  selectedLocations: PropTypes.arrayOf(PropTypes.shape({
    location_type: PropTypes.string,
    location_name: PropTypes.string,
  })),
  // addedComments: React.PropTypes.arrayOf(React.PropTypes.object),
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  toggleSection: PropTypes.func,
  t: PropTypes.func.isRequired,
};

WorkorderFormCard.defaultProps = {
  edit: false,
  workorderForm: {},
  onCancel: () => { },
  onSubmit: () => { },
  toggleSection: () => { },
};

export default localize(WorkorderFormCard);



// WEBPACK FOOTER //
// ./src/views/workorders/WorkorderFormCard.js